import { isActive, isAdminStore, isAdminSupervisor, isInventoryAccount, isIQA, isStore, isSupervisor, isTeamLead, isTechnicalSupervisor, isTechStore } from "../Authetication"
import { AiOutlineCluster, AiOutlineCompass, AiOutlineFundProjectionScreen, AiOutlineHome, AiOutlineLogout, AiOutlineProject } from "react-icons/ai"
import {BsGear, BsStack} from "react-icons/bs"
import {BiShoppingBag, BiTransferAlt} from "react-icons/bi"
import {TbTruckReturn} from "react-icons/tb"
import {MdOutlineApproval} from "react-icons/md"
import {HiOutlineDocumentReport} from "react-icons/hi"
import { FaRegUser } from "react-icons/fa"
export const NavList =(location)=>{
  

     let List = [
    
  
    {
        name: "dashboard",
        icon: <AiOutlineFundProjectionScreen />,
        link: "/dashboard",
        active: isActive(location, "/dashboard"),
        display: true
    },
    {
        name: "manage shelf",
        icon: <AiOutlineProject />,
        link: "/manage-shelf",
        active: isActive(location, "/manage-shelf"),
        display: isStore()
    },
    {
        name: "bin card",
        icon: <AiOutlineProject />,
        link: "/bin-card",
        active: isActive(location, "/bin-card"),
        display: true
    },
    {
        name: "transfer",
        icon: <BiTransferAlt/>,
        link: "/transfer",
        active: isActive(location, "/transfer"),
        display: isStore()
    },
    {
        name: "store received advise",
        icon: <AiOutlineCluster />,
        link: "/store-received-advise",
        active: isActive(location, "/store-received-advise"),
        display: isStore()
    },
    {
        name: "quality inspection",
        icon: <AiOutlineCluster />,
        link: "/quality-inspection",
        active: isActive(location, "/quality-inspection"),
        display: isIQA()
    },
    {
        name: "Inspect SCN",
        icon: <AiOutlineCluster />,
        link: "/inspect-SCN",
        active: isActive(location, "/inspect-SCN"),
        display: isIQA()
    },
   
    {
        name: "inventory account",
        icon: <AiOutlineProject />,
        link: "/inventory-account",
        active: isActive(location, "/inventory-account"),
        display: isInventoryAccount()
    },
   
    {
        name: "manage store",
        icon: <BsGear />,
        link: "/manage-store",
        active: isActive(location, "/manage-store"),
        display: isStore()
    },
    {
        name: "device assignment request",
        icon: <AiOutlineProject />,
        link: "/device-assignment-request",
        active: isActive(location, "/device-assignment-request"),
        display: isAdminStore()
    },
    {
        name: "device assignment procurement",
        icon: <AiOutlineProject />,
        link: "/device-assignment-procurement",
        active: isActive(location, "/device-assignment-procurement"),
        display: isAdminStore()
    },
    {
        name: "device assignment RTS",
        icon: <AiOutlineProject />,
        link: "/device-assignment-rts",
        active: isActive(location, "/device-assignment-rts"),
        display: isAdminStore()
    },
    {
        name: "pick up",
        icon: <BiShoppingBag />,
        link: "/pick-up",
        active: isActive(location, "/pick-up"),
        display: isStore()
    },
    {
        name: "pick up group",
        icon: <BiShoppingBag />,
        link: "/pick-up-group",
        active: isActive(location, "/pick-up-group"),
        display: isStore()
    },
    {
        name: "return to store",
        icon: <TbTruckReturn />,
        link: "/return-to-store",
        active: isActive(location, "/return-to-store"),
        display: isStore()

    },
    {
        name: "expected return to store",
        icon: <TbTruckReturn />,
        link: "/expected-return-to-store",
        active: isActive(location, "/expected-return-to-store"),
        display: isTechStore()

    },
    {
        name: "track SRA status",
        icon: <BsStack/>,
        link: "/track-SRA-status",
        active: isActive(location, "/track-SRA-status"),
        display: true
    },
    {
        name: "approved inventory account",
        icon: <BsStack/>,
        link: "/track-approved-inventory",
        active: isActive(location, "/track-approved-inventory"),
        display: true
    },
    {
        name: "Admin Approval",
        icon: <MdOutlineApproval/>,
        link: "/approval",
        active: isActive(location, "/approval"),
        display: isAdminSupervisor()
    },
    {
        name: "Technical Approval",
        icon: <MdOutlineApproval/>,
        link: "/technical-approval",
        active: isActive(location, "/technical-approval"),
        display: isTechnicalSupervisor()
    },
    {
        name: "Take Stock",
        icon: <MdOutlineApproval/>,
        link: "/take-stock",
        active: isActive(location, "/take-stock"),
        display: isInventoryAccount()
        // display: true
    },
    {
        name: "Stock Approval",
        icon: <MdOutlineApproval/>,
        link: "/stock-approval",
        active: isActive(location, "/stock-approval"),
        display: isSupervisor(),
        // display: true,
    },
    
    {
        name: "Inventory Account",
        icon: <MdOutlineApproval/>,
        link: "/inventory-account",
        active: isActive(location, "/inventory-account"),
        display: isTeamLead(),
        // display: true,
    },
    
    {
        name: "Team Lead Inventory",
        icon: <MdOutlineApproval/>,
        link: "/team-lead-inventory",
        active: isActive(location, "/team-lead-inventory"),
        display: isTeamLead(),
        // display: true,
    },
    {
        name: "User Management",
        icon: <FaRegUser />,
        link: "/user-management",
        active: isActive(location, "/user-management"),
        display: isTechnicalSupervisor() || isTechStore(),
        // display: true,
    },
    
    {
        name: "Report",
        icon: <HiOutlineDocumentReport/>,
        link: "/report",
        active: isActive(location, "/report"),
        display: true
    },
  
]

return List
} 